import ReturnItem from '../../fenix orders/retrun item/return-item';
import React, { useState, useEffect } from "react";
import dateFormat from 'dateformat';
import Pagination from '@mui/material/Pagination';
import { ORDER_HISTORY_SERACH, RETURNS_UI_URLS } from "../../../constants.js";
// RETURNS_UI_URLS
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useNavigate } from 'react-router-dom';
import './my-orders.scss';
import { Alert, FormControl, MenuItem, Select, Snackbar, InputAdornment, OutlinedInput, PaginationItem, Typography, ClickAwayListener } from '@mui/material';
import SimpleDialog from '../controlled-popup/popup.js';
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import infoIcon from "../../../assets/images/icons/info-icon.svg"
import closeIcon from "../../../assets/images/icons/close-icon.svg"
import downArrowIcon from "../../../assets/images/icons/down-arrow-icon.svg"
import whiteCheckIcon from "../../../assets/images/icons/white-check-icon.svg"
import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import ScrollToTop from '../../../components/ScrollToTop.js';
import HtmlTooltipForDetails from './HtmlTooltipForDetails.js';
import useWindowResize from '../../../hooks/useWindowResize.js';
import moment from 'moment/moment.js';

function MyOrders(props) {
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [obj, setObj] = useState("");
    const [filterData, setFilter] = useState([]);
    const [date, setDateValue] = useState('3Months');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [totalCount, setTotalCount] = React.useState(0)
    const [totalPages, setTotalPages] = React.useState(0);
    const [currentpage, setCurrentPage] = React.useState(1);
    let navigate = useNavigate();
    const [data1, setRetailerData] = React.useState({});
    const [lineDataArray, setLineDataArray] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [selectedDummyData, setSelectedDummyData] = React.useState({});
    const [orderId, setorderId] = useState('');
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [isLoaderEnable, setIsLoaderEnable] = useState(false);
    const [showtooltip, setShowTooltip] = useState(false);
    const [showTrackToolTip, setShowTrackToolTip] = useState(false);
    const [trackShow, setTrackShow] = useState(false);
    const [snackOpen, setSnackOpen] = React.useState(false);
    const [searchValuechange, setSearchValueChange] = React.useState(false);
    const [snackbarProp, setSnackbarProp] = useState({});
    const [searchValue, setSearchValue] = useState('');
    const [dialogType, setDialogType] = useState('');
    const [reasonData, setReasonData] = useState([]);
    let filterObj = props.data ? props.data : null;
    const [orderIdParam, setorderIdParam] = useState(null);
    const [ordernumber, setOrderNumber] = useState(null);
    const [zipcode, setZipcode] = useState('');
    const [searchFilters, setSearchFilters] = useState(null);

    const dateSelected = (event) => {
        setDateValue(event.target.value);
        setSearchValue('');
        setSearchFilters(null);
        if (event.target.value === '3Months') {
            let d = formatDate(new Date().setDate(new Date().getDate() - 90));
            setFromDate(d);
            let d1 = formatDate(new Date());
            setToDate(d1);
            setTimeout(() => {
                getOrderSearch(d, d1, '', '1', rowsPerPage);
            }, 1000);
        }
        else if (event.target.value === '6Months') {
            let d = formatDate(new Date().setDate(new Date().getDate() - 180));
            setFromDate(d);
            let d1 = formatDate(new Date());
            setToDate(d1);
            setTimeout(() => {
                getOrderSearch(d, d1, '', '1', rowsPerPage);
            }, 1000);
        }
        else if (event.target.value === 'year') {
            let d = formatDate(new Date().setDate(new Date().getDate() - 365));
            setFromDate(d);
            let d1 = formatDate(new Date());
            setToDate(d1);
            setTimeout(() => {
                getOrderSearch(d, d1, '', '1', rowsPerPage);
            }, 1000);
        }
        else if (event.target.value === 'Last30days') {
            let d = formatDate(new Date().setDate(new Date().getDate() - 30));
            setFromDate(d);
            let d1 = formatDate(new Date());
            setToDate(d1);
            setTimeout(() => {
                getOrderSearch(d, d1, '', '1', rowsPerPage);
            }, 1000);
        }
        else if (event.target.value === 'Last15days') {
            let d = formatDate(new Date().setDate(new Date().getDate() - 15));
            setFromDate(d);
            let d1 = formatDate(new Date());
            setToDate(d1);
            setTimeout(() => {
                getOrderSearch(d, d1, '', '1', rowsPerPage);
            }, 1000);
        }
        else if (event.target.value === "Last7days") {
            let d = formatDate(new Date().setDate(new Date().getDate() - 7));
            setFromDate(d);
            let d1 = formatDate(new Date());
            setToDate(d1);
            setTimeout(() => {
                getOrderSearch(d, d1, '', '1', rowsPerPage);
            }, 1000);
        }
    };
    const formatDate = (event) => {
        return (new Date(event)).toISOString().split('T')[0];;
    }

    const formatingDateForDisplay = (date) => {
        return moment(date?.split('T')[0])?.format('MMMM D, YYYY')
        // return date ? dateFormat(date.split('T')[0], "mmmm d, yyyy") : '';
    }

    const handleCallback = (value) => {
        if (value === '2') {
            props.passChildData(value);
        }
        else if (value) {
            setSearchValue('')
            setSearchFilters(null);
            setIsSubmitted(false);
            sessionStorage.removeItem('returnItemData');
            sessionStorage.removeItem('RPI');
            setLineDataArray([]);
            let d = formatDate(new Date().setDate(new Date().getDate() - 90));
            setFromDate(d);
            let d1 = formatDate(new Date());
            setToDate(d1);
            getOrderSearch(d, d1, null, '1', rowsPerPage, ordernumber, zipcode, orderIdParam);
            let data2 = '/my-orders' + (document.location.search ? document.location.search : '');
            navigate(data2.replace(/"/g, ""));
        }
        else {
            setIsSubmitted(false);
            sessionStorage.removeItem('RPI');
            setLineDataArray(JSON.parse(sessionStorage.getItem('returnItemData'))?.line_data);
            setorderId(JSON.parse(sessionStorage.getItem('returnItemData'))?.order_id);
            setTimeout(() => {
                scrollToParticularSection('itemId' + JSON.parse(sessionStorage.getItem('returnItemData'))?.line_data[0]?.id)
            }, 200);
            let data2 = '/my-orders' + (document.location.search ? document.location.search : '');
            navigate(data2.replace(/"/g, ""));
        }
    }
    const openDialogForCheckbox = () => {
        setOpen(true);
    };

    const handleClearSearch = () => {
        setSearchValue('');
        setSearchFilters(null);
        getOrderSearch(fromDate, toDate, null, '1', rowsPerPage);
        sessionStorage.setItem('isSelectedLineItems', false);
    }
    const [searchValueDummy, setSearchValueDummy] = useState('');
    const searchParams = (event, value) => {
        event.preventDefault();
        setSearchValue(value);
        setSearchValueChange(true);
        if (value.length > 3 || value.length !== 0) {
            let filters = {
                "criteria_type": "Contains",
                "field_name": "order_number",
                "field_type": "TEXT",
                "value": value
            }
            setSearchFilters(filters);
            setSearchValueDummy(JSON.parse(JSON.stringify(value)));
            sessionStorage.setItem('isSelectedLineItems', false);
            getOrderSearch(fromDate, toDate, filters, '1', rowsPerPage);
        }
        else {
            setSearchFilters(null);
            getOrderSearch(fromDate, toDate, null, '1', rowsPerPage);
        }
    }

    const dialogClose = (value) => {
        setOpen(false);
        if (dialogType === 'checkbox' && value) {
            if (value) {
                let array = [];
                array.push(selectedDummyData.data)
                setLineDataArray(array);
                setorderId(selectedDummyData.id);
                setSelectedIndex(selectedDummyData.index)
                scrollToParticularSection('itemId' + selectedDummyData.index);
                sessionStorage.removeItem('returnItemData');
                sessionStorage.removeItem('selectedReasonData');
                sessionStorage.removeItem('selectedDummyReasonData');
                sessionStorage.removeItem('isSelectedLineItems');
                sessionStorage.removeItem('RPI');
            }
            else {
                scrollToParticularSection('itemId' + selectedIndex)
            }
        }
    };

    const scrollToParticularSection = (id) => {
        const violation = document.getElementById(id);
        var headerOffset = 45;
        var elementPosition = violation?.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.scrollY - headerOffset;
        violation?.scrollIntoView({
            top: offsetPosition,
            block: 'center',
        });
    }
    const updateOrderInfoHeight = () => {
        setTimeout(() => {

            let orderInfoWrappers = document.querySelectorAll('.order-info-wrapper.auto-overflowY')
            // Iterate over each wrapper
            orderInfoWrappers.forEach((wrapper) => {
                let children = wrapper.children;
                let totalHeight = 0;

                // Calculate the combined height of the first three children
                for (let i = 0; i < Math.min(3, children.length); i++) {
                    totalHeight += children[i].offsetHeight;
                }

                // Update the max-height style of the wrapper
                wrapper.style.maxHeight = `${totalHeight - 2}px`;
            });
        }, [300])
    }

    useWindowResize(() => {
        updateOrderInfoHeight()
    })


    useEffect(() => {
        let params = new URLSearchParams(document.location.search);
        let o = decodeURIComponent(params.get("ordernumber"));
        setOrderNumber(o);
        let orderId = params.get("orderid");
        setorderIdParam(orderId);
        let z = params.get("zipcode");
        setZipcode(z);
        setTimeout(() => {
            if (sessionStorage.getItem('returnItemData') && sessionStorage.getItem('RPI')) {
                setObj(JSON.parse(sessionStorage.getItem('returnItemData')));
                setIsSubmitted(sessionStorage.getItem('returnItemData') ? true : false);
            }
        }, 500);
        if (JSON.parse(sessionStorage.getItem('tabIndex')) !== '2' && !document.location.href.includes('my-returns')) {
            setRetailerData(JSON.parse(sessionStorage.getItem('retailerData')));
            window.scrollTo(0, 0);
            let d = formatDate(new Date().setDate(new Date().getDate() - 90));
            setFromDate(d);
            let d1 = formatDate(new Date());
            setToDate(d1);
            setSearchValue('');
            setSearchFilters(null);
            getOrderSearch(d, d1, null, '1', 10, o, z, orderId);
        }
    }, [filterObj]);

    const getOrderSearch = async (from, to, params, pageNo, size, o, z, orderId) => {
        setIsLoaderEnable(true);
        setLineDataArray([]);
        let d;
        if (o && z) {
            d = {
                "filters": [
                    {
                        "criteria_type": "Equals",
                        "field_name": "order_number",
                        "field_type": "TEXT",
                        "value": o
                    },
                    {
                        "criteria_type": "Equals",
                        "field_name": "buyer_address.zip_code",
                        "field_type": "TEXT",
                        "value": z
                    }
                ],
                "search_params": []
            }
        }
        else if (orderId) {
            d = {
                "filters": [
                    {
                        "criteria_type": "Equals",
                        "field_name": "order_id",
                        "field_type": "TEXT",
                        "value": orderId
                    }
                ],
                "search_params": []
            }
        }
        else if (JSON.parse(sessionStorage.getItem('email'))) {
            d = {
                "filters": [
                    {
                        "criteria_type": "Greater than or equal",
                        "field_name": "placed_dttm.formatted_dttm",
                        "field_type": "TIMESTAMP",
                        "value": from + "T00:00:00-05:00"
                    },
                    {
                        "criteria_type": "Less than or equal",
                        "field_name": "placed_dttm.formatted_dttm",
                        "field_type": "TIMESTAMP",
                        "value": to + "T23:59:59-05:00"
                    },
                    {
                        "criteria_type": "Equals",
                        "field_name": "customer.email",
                        "field_type": "TEXT",
                        "value": JSON.parse(sessionStorage.getItem('email'))
                    },
                ],
                "search_params": []
            }
        }

        if (params) {
            d.filters = [params];
            let g = {
                "criteria_type": "Equals",
                "field_name": "customer.email",
                "field_type": "TEXT",
                "value": JSON.parse(sessionStorage.getItem('email'))
            }
            d.filters.push(g);
        }
        try {
            const response = await fetch(ORDER_HISTORY_SERACH.ORDER_NUMBER_AND_EMAIL + (pageNo ? pageNo : '1') + '&size=' + (size ? size : 10), {
                method: 'POST',
                body: JSON.stringify(d),
                headers: {
                    'Content-Type': 'application/json',
                    'X-Fenix-Tenant-Id': (JSON.parse(sessionStorage.getItem('retailerData')).tenantId)
                }
            });
            if (!response) {
                setIsLoaderEnable(false);
                setSnackOpen(true);
                setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
                setFilter(null)
            }
            if (response?.status === 200) {
                const result = await response.json();
                setTimeout(() => {
                    if (result?.data) {
                        setTotalCount(result.meta?.total_count);
                        setTotalPages(result.meta?.total_pages);
                        setCurrentPage(result.meta?.current_pages + 1);
                        setPage(result.meta?.current_pages);
                        setFilter(result?.data);
                        updateOrderInfoHeight()
                    }
                    else {
                        setTotalCount(0);
                        setTotalPages(0);
                        setFilter(null);
                        updateOrderInfoHeight()
                    }
                    setIsLoaderEnable(false);
                }, 1000);
            }
            else {
                setFilter(null);
                setSnackOpen(true);
                setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
                setIsLoaderEnable(false);
                setTotalCount(0);
                setTotalPages(0);
                updateOrderInfoHeight()
            }
        }
        catch (error) {
            setSnackOpen(true);
            setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
            setIsLoaderEnable(false);
            setFilter(null);
            setTotalCount(0);
            setTotalPages(0);
        }
    }

    const onReturnItem = async (data, linedata) => {
        let d = {
            'order_id': data.order_id,
            'order_number': data.order_number,
            'date_place': data.placed_dttm,
            'price': data.total_price?.amount,
            'currency_code': data.total_price?.currency_code,
            'address': data?.buyer_address,
            'line_data': linedata,
            'email': JSON.parse(sessionStorage.getItem('email')),
        }
        setObj(d);
        let array = [];
        for (let i = 0; i < linedata.length; i++) {
            let lineDataobj = {
                "sku": linedata[i].sku,
                "quantity": linedata[i].returnable_quantity,
                "shipment_id": linedata[i].shipment_id
            }
            array.push(lineDataobj)
        }
        let d1 = {
            "order_id": data.order_id,
            "line_items": array,
        }
        try {
            const response = await fetch(RETURNS_UI_URLS.BASE_URL + 'return/return-process-initialization', {
                method: 'POST',
                body: JSON.stringify(d1),
                headers: {
                    'Content-Type': 'application/json',
                    'X-Fenix-Tenant-Id': (JSON.parse(sessionStorage.getItem('retailerData')).tenantId)
                }
            })
            if (!response) {
                setSnackOpen(true);
                setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
            }

            if (response?.status === 200) {
                const result = await response.json();
                setReasonData(result?.consolidated_return_attributes);
                sessionStorage.setItem('RPI', JSON.stringify(result));
                sessionStorage.setItem('returnItemData', JSON.stringify(d));
                let data2 = '/my-orders/return' + (document.location.search ? document.location.search : '');
                navigate(data2.replace(/"/g, ""));
                setIsSubmitted(true);
            }
            else {
                setSnackOpen(true);
                setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
            }
        }
        catch (error) {
            setSnackOpen(true);
            setSnackbarProp({ style: 'error', msg: 'Fetching data is unsuccessfull.' });
        }

    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackOpen(false);
    };

    // let data = [];
    const setCheckbox = (event, value, shipId, i, id) => {
        if (lineDataArray.length > 0 ? orderId === id : true) {
            if (event === true) {
                let array = [...lineDataArray];
                value.shipment_id = shipId;
                array.push(value)
                setLineDataArray(array);
                sessionStorage.setItem('isSelectedLineItems', true);
            }
            else {
                let array = [...lineDataArray];
                let index = array.findIndex((obj) => obj.id === value.id);
                if (index !== -1) {
                    array.splice(index, 1)
                    setLineDataArray(array);
                }
                if (array.length > 0) {
                    sessionStorage.setItem('isSelectedLineItems', true);
                }
                else {
                    sessionStorage.setItem('isSelectedLineItems', false);
                }

            }
            setSelectedIndex(i)
            setorderId(id);
        } else {
            setDialogType('checkbox');
            openDialogForCheckbox();
            value.shipment_id = shipId;
            setSelectedDummyData({ id: id, data: value, index: i });
        }

    }

    const isChecked = (lineId,shipId) => {
        let flag = false;        
        for (let i = 0; i < lineDataArray?.length; i++) {
            if (lineDataArray[i].id === lineId && lineDataArray[i].shipment_id === shipId) {
                flag = true;
                break;
            }
            else {
                flag = false;
            }
        }
        return flag;
    }

    const NoIcon = styled('span')(({ theme }) => ({
        display: 'none',
    }));

    const HtmlTooltipForAddress = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            fontSize: theme.typography.pxToRem(12),
            border: '2px solid #dadde9',
        },
    }));
    const handleChangePage = (event, newpage) => {
        setPage(newpage);
        scrollToParticularSection('top-section');
        getOrderSearch(fromDate, toDate, searchFilters, newpage, rowsPerPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(1);
        getOrderSearch(fromDate, toDate, searchFilters, '1', parseInt(event.target.value, 10));
    };
    const quantityValueBind = (value) => {
        if (lineDataArray?.length > 0) {
            let index = lineDataArray.findIndex((obj) => obj.id === value?.id);
            if (index !== -1) {
                return lineDataArray[index].returnable_quantity;
            } else {
                return value?.returnable_quantity;
            }
        }
        else {
            return value?.returnable_quantity > 0 ? value?.returnable_quantity : '0';
        }
    }

    const quantityValueBindForNonShipped = (value) => {
        if (lineDataArray?.length > 0) {
            for (let i = 0; i < lineDataArray.length; i++) {
                if (lineDataArray[i]?.id === value?.id) {
                    return lineDataArray[i].returnable_quantity;
                }
                else {
                    return value?.quantity;
                }
            }
        }
        else {
            return value?.quantity > 0 ? value?.quantity : '0';
        }
    }

    const quantityDisable = (value) => {
        let flag = true;
        if (lineDataArray?.length > 0) {
            for (let i = 0; i < lineDataArray.length; i++) {
                if (lineDataArray[i]?.id === value?.id) {
                    flag = false;
                    break;
                }
                else {
                    flag = true;
                }
            }
        }
        else {
            flag = true;
        }
        return flag;
    }

    const quantityChange = (event, value) => {
        let array = [...JSON.parse(JSON.stringify(lineDataArray))];
        let index = array.findIndex((obj) => obj.id === value);
        if (index !== -1) {
            array[index].returnable_quantity = Number(event.target.value);
        }
        setLineDataArray(JSON.parse(JSON.stringify(array)));
    }

    const returnSummaryBind = (data, message) => {        
        return message[data[0]?.return_status]+''+ formatingDateForDisplay(data[0]?.event_dttm);
    }

    const displaySizeandColor = (size, color, qty) => {
        return size && color ? (<>{qty && <span>Order Qty: {qty}</span>}<span>{data1?.type === 'janieandjack' ? 'Size:' : 'Variant:'} {size}</span><span className='display-ellipsis width-25vw'>Color: {color}</span></>) : (size && !color ? <>{qty && <span>Order Qty: {qty}</span>} <span className='text-nowrap'>{data1?.type === 'janieandjack' ? 'Size:' : 'Variant:'} {size}</span></> : (!size && color ?<>{qty && <span>Order Qty: {qty}</span>} <span className='display-ellipsis width-25vw'>Color: {color}</span></> : ''))
    }

    const trackingRoute = (carrierName, number) => {

        let upsurl = 'https://www.ups.com/track?loc=en_US&requester=ST&trackingNumber=' + number + '/trackdetails';
        let fedexurl = 'https://www.fedex.com/fedextrack/?trknbr=' + number;
        let uspsurl = ' https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=' + number;
        let canadaposturl = 'https://www.canadapost-postescanada.ca/track-reperage/en#/details/' + number;
        let dhlecommerceurl = 'https://webtrack.dhlglobalmail.com/orders?trackingNumber=' + number;
        switch (carrierName) {
            case 'UPS':
                return window.open(upsurl)
            case 'DHL_ECOMMERCE':
                return window.open(dhlecommerceurl)
            case 'USPS':
                return window.open(uspsurl)
            case 'FEDEX':
                return window.open(fedexurl)
            case 'CANADAPOST':
                return window.open(canadaposturl)
            default:
                return;
        }

    }

    const addDefaultImg = ev => {
        ev.target.src = "/shopping-bag.png";
        ev.target.style = 'width:45%';
    }

    const handleTouchStart = () => {
        setShowTooltip(true);
    }
    const handleTouchEnd = () => {
        setShowTooltip(false)
    }

    const handleTouchStartForTrack = () => {
        setTrackShow(true);
        // setShowTrackToolTip(true);
    }
    const handleTouchEndForTrack = () => {
        // setTrackShow(false);
        setShowTrackToolTip(false)
    }

    const gobacktologin = () => {
        let data2 = '/login'
        navigate(data2.replace(/"/g, ""));
    }
    const backspaceCall = (e, value) => {
        if (value.length === 0 && e.key === 'Backspace') {
            e.preventDefault();
            setSearchValue(value)
            searchParams(e, value)
        }
    }

    const preventOuterScroll = (event) =>{
        let el = this;
        let scrollTop = el.scrollTop;
        let scrollHeight = el.scrollHeight;
        let height = el.clientHeight;
        let deltaY = event.type === "wheel" ? event.deltaY : event.touches[0].clientY - (el.lastTouchY || 0);
        el.lastTouchY = event.touches[0]?.clientY || 0;
        let scrollingDown = deltaY > 0;
        let scrollingUp = deltaY < 0;
        if ((scrollingUp && scrollTop === 0) || (scrollingDown && scrollTop + height >= scrollHeight)) {
          event.preventDefault(); // Prevent outer scroll
        }
      }
      // Apply to the scrollable element
      const innerScroll = document.querySelector('.inner-scroll');
      innerScroll?.addEventListener('wheel', preventOuterScroll,  false );
      innerScroll?.addEventListener('touchmove', preventOuterScroll, false);
     
    
    const renderForm = (
        <div className="container my-orders-wrapper" id="top-section">
            {sessionStorage.getItem('email') ? <div className="row my-orders-header">
                <div className="col-sm-8 col-md-6 col-12">
                    <div className='d-flex align-items-center order-place-lb-select'>
                        <label className={`f-16 order-place-in-label ${data1?.type}`}> <span className="fw-600">{totalCount ? totalCount : '0'} order(s)</span> {!(searchValuechange && searchValue) ? 'placed in' : 'found'} </label>
                        {(searchValuechange && searchValue) ? '' :
                            <FormControl sx={{ m: 0 }} className={`form-control placed-in-select ${data1?.type}`}>
                                <Select
                                    className={`${data1?.type} form-select p-10 search-border f-14 fw-500 past-days-wrapper`}
                                    classes={{
                                        iconOpen: 'MuiSelect-icon-opened'
                                    }}
                                    IconComponent={NoIcon}
                                    defaultValue={date}
                                    onChange={dateSelected}
                                    labelId="demo-simple-select-helper-label"
                                    id="demo-simple-select-helper">
                                    <MenuItem className={`${data1?.type + '-menuitem'}`} value='Last7days'>Past 7 days</MenuItem>
                                    <MenuItem className={`${data1?.type + '-menuitem'}`} value='Last15days'>Past 15 days</MenuItem>
                                    <MenuItem className={`${data1?.type + '-menuitem'}`} value='Last30days'>Past 30 days</MenuItem>
                                    <MenuItem className={`${data1.type + '-menuitem'}`} value='3Months'>Past 3 Months</MenuItem>
                                    <MenuItem className={`${data1.type + '-menuitem'}`} value='6Months'>Past 6 Months</MenuItem>
                                    <MenuItem className={`${data1.type + '-menuitem'}`} value='year'>Past year</MenuItem>

                                </Select>
                            </FormControl>
                        }
                    </div>
                </div>
                {sessionStorage.getItem('email') && !document.location.href.includes('my-orders/return') ?
                    <div className="col-sm-4 col-md-6 input-wrapper justify-content-sm-end col-12">
                        <form onSubmit={e => searchParams(e, searchValue)} >
                            <FormControl fullWidth sx={{ m: 1 }}>
                                <OutlinedInput className={`fw-500 search-order-number-input form-control ${data1?.type}`}
                                    id="outlined-adornment-amount" onKeyUp={e => backspaceCall(e, e.target.value)} inputProps={{ maxLength: 16, }} placeholder='Search by order number'
                                    value={searchValue} onChange={e => searchParams(e, e.target.value)}
                                    startAdornment={<InputAdornment position="start">
                                        <IconButton onClick={handleClearSearch} edge="end">
                                            {searchValue?.length > 0 ? <ClearIcon className='f-14' /> : null}
                                        </IconButton>
                                    </InputAdornment>}
                                    label="Amount" endAdornment={<InputAdornment position="end">
                                        {/* <Button type='submit' disabled={!searchValuechange} ><ArrowForwardIcon className={`${!searchValuechange ? 'no-pointer-events cursor-not-allowed op-5' : 'cursor-pointer primary-color'}`} /></Button> */}
                                    </InputAdornment>}
                                />
                            </FormControl>
                        </form>
                        {/* <ClickAwayListener
                        onClickAway={()=>{setShowFilters(false)}}
                        >
                            <div className='filter_container'>
                                <button className='filter_btn' onClick={()=>{setShowFilters(!showFilters)}}>
                                    <img src={filterIcon} alt='filterIcon' />
                                    Filters
                                </button>
                                <div className={`filter_wrapper ${showFilters?'show':''}`}>
                                    <div className='filter_header d-flex align-items-center justify-content-between'>
                                        <h3 className='m-0'>Filter</h3>
                                        <button onClick={()=>{setShowFilters(false)}}>
                                            <img src={closeIcon} alt='closeIcon' width={18} height={18} />
                                        </button>
                                    </div>
                                    <div className='filter_content'>
                                        <div className='row'>
                                            <div className='col-12 filter-form-group-list'>
                                                <div className="form-group">
                                                    <label className="main-label">Delivery Status</label>
                                                    <div className="checkbox-list">
                                                        <div className='checkbox-wrapper'>
                                                            <input type="checkbox" name="deliveryStatus" id='notShipped'/>
                                                            <label htmlFor="notShipped">
                                                                <span>
                                                                    <img src={whiteCheckIcon} alt='checkIcon' />
                                                                </span>
                                                                Not Shipped
                                                            </label>
                                                        </div>
                                                        <div className='checkbox-wrapper'>
                                                            <input type="checkbox" name="deliveryStatus" id='delivered'/>
                                                            <label htmlFor="delivered">
                                                                <span>
                                                                    <img src={whiteCheckIcon} alt='checkIcon' />
                                                                </span>
                                                                Delivered
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-12 filter-form-group-list'>
                                                <div className="form-group">
                                                    <label className="main-label">Seller Name</label>
                                                    <div className='filter-form-input'>
                                                        <FormControl fullWidth sx={{ m: 1 }}>
                                                            <OutlinedInput 
                                                                className={`fw-500 search-order-number-input form-control ${data1?.type}`}
                                                                inputProps={{ maxLength: 16, }} 
                                                                placeholder='Medium'
                                                                value={""} 
                                                                onChange={()=>{}}
                                                                startAdornment={<InputAdornment position="start">
                                                                    <IconButton onClick={handleClearSearch} edge="end">
                                                                        {searchValue?.length > 0 ? <ClearIcon className='f-14' /> : null}
                                                                    </IconButton>
                                                                </InputAdornment>}
                                                                label="Amount" 
                                                                endAdornment={
                                                                    <InputAdornment position="end">
                                                                        {/* <Button type='submit' disabled={!searchValuechange} >
                                                                            <ArrowForwardIcon className={`${!searchValuechange ? 'no-pointer-events cursor-not-allowed op-5' : 'cursor-pointer primary-color'}`} />
                                                                        </Button> 
                                                                    </InputAdornment>
                                                                }
                                                            />
                                                        </FormControl>
                                                    </div>
                                                    <div className="checkbox-list">
                                                        <div className='checkbox-wrapper'>
                                                            <input type="checkbox" name="sellerName" id='adidas'/>
                                                            <label htmlFor="adidas">
                                                                <span>
                                                                    <img src={whiteCheckIcon} alt='checkIcon' />
                                                                </span>
                                                                Adidas
                                                            </label>
                                                        </div>
                                                        <div className='checkbox-wrapper'>
                                                            <input type="checkbox" name="sellerName" id='urbanThreads'/>
                                                            <label htmlFor="urbanThreads">
                                                                <span>
                                                                    <img src={whiteCheckIcon} alt='checkIcon' />
                                                                </span>
                                                                Urban Threads
                                                            </label>
                                                        </div>
                                                        <div className='checkbox-wrapper'>
                                                            <input type="checkbox" name="sellerName" id='glamourEmpire'/>
                                                            <label htmlFor="glamourEmpire">
                                                                <span>
                                                                    <img src={whiteCheckIcon} alt='checkIcon' />
                                                                </span>
                                                                Glamour Empire
                                                            </label>
                                                        </div>
                                                        <div className='checkbox-wrapper'>
                                                            <input type="checkbox" name="sellerName" id='casualCravers'/>
                                                            <label htmlFor="casualCravers">
                                                                <span>
                                                                    <img src={whiteCheckIcon} alt='checkIcon' />
                                                                </span>
                                                                casual Cravers
                                                            </label>
                                                        </div>
                                                        <div className='checkbox-wrapper'>
                                                            <input type="checkbox" name="sellerName" id='chicBeacon'/>
                                                            <label htmlFor="chicBeacon">
                                                                <span>
                                                                    <img src={whiteCheckIcon} alt='checkIcon' />
                                                                </span>
                                                                Chic Beacon
                                                            </label>
                                                        </div>
                                                        <div className='checkbox-wrapper'>
                                                            <input type="checkbox" name="sellerName" id='modernMetro'/>
                                                            <label htmlFor="modernMetro">
                                                                <span>
                                                                    <img src={whiteCheckIcon} alt='checkIcon' />
                                                                </span>
                                                                Modern Metro
                                                            </label>
                                                        </div>
                                                        <div className='checkbox-wrapper'>
                                                            <input type="checkbox" name="sellerName" id='eliteWave'/>
                                                            <label htmlFor="eliteWave">
                                                                <span>
                                                                    <img src={whiteCheckIcon} alt='checkIcon' />
                                                                </span>
                                                                Elite Wave
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <a href="#" className='view_all_btn mt-3'>View All</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='filter_footer d-flex align-items-center justify-content-between'>
                                        <h3 className='m-0'>Clear All</h3>
                                        <button className='filter_apply_btn'>Apply</button>
                                    </div>
                                </div>
                            </div>
                        </ClickAwayListener> */}
                    </div> : ''}
            </div> : ''}
            <div className="row" >
                <div className="col-12 card-wrap order-placed-list">
                    {filterData?.length > 0 ? (filterData?.map((data, key) => (
                        <div key={data.order_id}>
                            <div className="card order-placed-list-box">
                                <div className="card-header row mx-0 align-items-start" key={key}>
                                    <div className='col-md-8 cheader-headings-wrap'>
                                        <div className="cheader-headings">
                                            <div className={`cheader-label ${data1?.type}`}>Order Placed</div>
                                            <div className={`fw-600 ${data1?.type} cheader-title`}>{data.placed_dttm?.formatted_dttm ? formatingDateForDisplay(data.placed_dttm.formatted_dttm) : ''}</div>
                                        </div>
                                        {data1?.type !== 'janieandjack' ? <div className="cheader-headings">
                                            <div className={`cheader-label ${data1?.type}`}>Total</div>
                                            <div className={`fw-600 ${data1?.type} cheader-title`}>${data.total_price?.amount ? data.total_price?.amount.toFixed(2) : '0'}</div>
                                        </div> : ''}
                                        <div className="cheader-headings ship-to-headings">
                                            <div className={`cheader-label ${data1?.type}`}>Ship to</div>
                                            <HtmlTooltipForAddress enterTouchDelay={0}
                                                className= {`shipto-tooltip ${data1?.type}`}
                                                title={
                                                    <React.Fragment>
                                                        <div onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} >
                                                            <h4>{data?.buyer_address?.name}</h4>
                                                            <p>{data?.buyer_address?.address1} {data?.buyer_address?.city},&nbsp;{data?.buyer_address?.province} {data?.buyer_address?.country}, {data?.buyer_address?.zip_code}</p>
                                                        </div>
                                                    </React.Fragment>
                                                }>
                                                <div className={`fw-600 ${data1?.type} cursor-pointer cheader-title`}>
                                                    {data?.buyer_address?.name}
                                                    <span className="text-color">
                                                        <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M11.2126 0.671822C11.4957 0.945189 11.4957 1.3884 11.2126 1.66177L6.37841 6.32844C6.09523 6.60181 5.63611 6.60181 5.35293 6.32844L0.787335 1.92103C0.504156 1.64766 0.504156 1.20445 0.787335 0.931081C1.07051 0.657714 1.52964 0.657714 1.81282 0.931081L5.86567 4.84351L10.1871 0.671822C10.4703 0.398455 10.9294 0.398455 11.2126 0.671822Z" fill="#78829D" />
                                                        </svg>

                                                    </span>
                                                </div>
                                            </HtmlTooltipForAddress>
                                        </div>
                                    </div>
                                    <div className="col-md-4 cheader-order-number">
                                        <div className="cheader-headings">
                                            <div className={`fw-600 cheader-label ${data1?.type}`}>Order Number: </div>
                                            <div className={`fw-600 ${data1?.type} cheader-title`}>{data.order_number}</div>
                                        </div>
                                    </div>
                                    <div className='col-12 order-number-container'>
                                        <div className='order-number-header'>
                                            <span className='order-number-title'>Order Number:</span>
                                            <span className={`order-number-value fw-600 ${data1?.type} cursor-pointer`}>{data.order_number} </span>
                                        </div>
                                    </div>
                                </div>
                                {data?.shipments?.length > 0 || data?.non_shipped_line_items ? <div className='card-body'>
                                    {data?.shipments?.length > 0 && <div className={`row mx-0`}>
                                        <div className="col-md-12 card-body-inner">

                                            {data?.shipments?.map((shipmentdata, i) => {
                                                if (i !== 0) {
                                                    return null;
                                                }
                                                return (
                                                    <div key={i} className={`text-right d-none d-md-flex return-item-button-wrapper justify-content-end align-items-end ${data?.shipments?.length > 1 || shipmentdata?.line_items?.length > 3 ? 'sticky-button' : ''}`}>
                                                        {
                                                            !(lineDataArray?.length > 0 && data?.order_id === orderId) ?
                                                                <HtmlTooltipForAddress enterTouchDelay={0}
                                                                    title={
                                                                        <React.Fragment>
                                                                            <div onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} className="fw-500">Please select lineitems to enable button</div>
                                                                        </React.Fragment>
                                                                    }
                                                                >
                                                                    {showtooltip || (
                                                                        <button className={`${data1?.type ? data1.type + '-btn' : ''} ${data1?.type === 'fluentcommerce' ? 'full-width' : ''} return-item-button card-header-return-btn ${lineDataArray?.length > 0 && data.order_id === orderId ? '' : 'disabled-btn'}`} onClick={() => onReturnItem(data, lineDataArray)} >
                                                                            Return Item(s)
                                                                        </button>
                                                                    )}
                                                                </HtmlTooltipForAddress>
                                                                : <button disabled={!(lineDataArray?.length > 0 && data.order_id === orderId)} className={`${data1?.type ? data1.type + '-btn' : ''} ${data1?.type === 'fluentcommerce' ? 'full-width' : ''} return-item-button card-header-return-btn ${lineDataArray.length > 0 && data.order_id === orderId ? '' : 'disabled-btn'}`} onClick={() => onReturnItem(data, lineDataArray)} title='Return Item(s)'>
                                                                    Return Item(s)
                                                                </button>
                                                        }
                                                    </div>
                                                )

                                            })}

                                            {data?.shipments?.map((shipmentdata, i) => {
                                                return (
                                                    <div key={i} id={`itemId` + key}>
                                                        <div className={`card-subheader ${data?.shipments?.length > 1 || shipmentdata?.line_items?.length > 3 ? 'sticky-header' : ''}`}>
                                                            <div className='card-subheader-left'>
                                                                <div className={`fw-400 label-sold-shipped ${data1.type}`}>Product(s) Sold and Shipped by: <span className={`fw-600 ${data1.type}`}>{shipmentdata?.vendor ? shipmentdata?.vendor : data1.vendorName}</span></div>
                                                                {/* <div className='card-subheader-right d-flex align-items-center justify-content-between'> */}
                                                                <div className='order-delivered-container'>
                                                                    <HtmlTooltipForDetails
                                                                        enterTouchDelay={0} leaveDelay={1000}
                                                                        className="order-delivered-tooltip"
                                                                        title={
                                                                            <React.Fragment>
                                                                                {trackShow && <><div onTouchStart={handleTouchStartForTrack} onTouchEnd={handleTouchEndForTrack}>
                                                                                    <div className={`order-delivered-tooltip-header ${data1.type}`}>
                                                                                        <div className='order-delivered-tooltip-header-left p-10'>
                                                                                            <h3>Courier Partner: {shipmentdata.tracking_summary?.tracking_carrier}</h3>
                                                                                            {shipmentdata.tracking_summary?.tracking_number ?
                                                                                                <span><span>Tracking ID: </span><a target='_blank' className={`rpolicy-link cursor-pointer ${data1.type}`} onClick={() => trackingRoute(shipmentdata.tracking_summary?.tracking_carrier, shipmentdata.tracking_summary?.tracking_number)}>{shipmentdata.tracking_summary?.tracking_number}</a></span>
                                                                                                : ''}
                                                                                            {shipmentdata.tracking_summary?.delivery_status !== 'DELIVERED' ?
                                                                                                <span>{shipmentdata.tracking_summary?.expected_delivery_dttm ? <span>Exp Delivery Date: </span> : ''}{shipmentdata.tracking_summary?.expected_delivery_dttm?.formatted_dttm ? formatingDateForDisplay(shipmentdata.tracking_summary?.expected_delivery_dttm?.formatted_dttm) : ''}</span> : ''
                                                                                            }

                                                                                        </div>

                                                                                        <div className='order-delivered-tooltip-header-right'>
                                                                                            <button>
                                                                                                <img src={closeIcon} onClick={e => setTrackShow(false)} alt='closeIcon' />
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className={`order-delivered-tooltip-body ${data1.type}`}>
                                                                                        <Timeline
                                                                                            sx={{
                                                                                                [`& .${timelineItemClasses.root}:before`]: {
                                                                                                    flex: 0,
                                                                                                    padding: 0,
                                                                                                },
                                                                                            }}
                                                                                        >
                                                                                            <TimelineItem className={`${shipmentdata?.tracking_summary?.delivery_status === 'DELIVERED' || shipmentdata?.tracking_summary?.delivery_status === 'READY_TO_SHIP' || shipmentdata?.tracking_summary?.delivery_status === 'SHIPMENT_CONFIRMED' || shipmentdata?.tracking_summary?.delivery_status === 'OUT_FOR_DELIVERY' || shipmentdata?.tracking_summary?.delivery_status === 'INTRANSIT' || shipmentdata?.tracking_summary?.delivery_status === 'PICKED_UP_BY_CARRIER' ? "completed-timeline " : ''} ${shipmentdata?.tracking_summary?.delivery_status === 'DELIVERED' || shipmentdata?.tracking_summary?.shipment_event ? '' : 'active-timeline'}`}>
                                                                                                <TimelineSeparator>
                                                                                                    <TimelineDot />
                                                                                                    <TimelineConnector />
                                                                                                </TimelineSeparator>
                                                                                                <TimelineContent>
                                                                                                    <div className='order-timeline-content'>
                                                                                                        <h3>Order Confirmed</h3>
                                                                                                        <span>
                                                                                                            <label>{data.placed_dttm?.formatted_dttm ? formatingDateForDisplay(data.placed_dttm.formatted_dttm) : ''}</label>
                                                                                                        </span>
                                                                                                    </div>
                                                                                                </TimelineContent>
                                                                                            </TimelineItem>
                                                                                            <TimelineItem className={`${shipmentdata?.tracking_summary?.delivery_status === 'DELIVERED' || shipmentdata?.tracking_summary?.delivery_status === 'OUT_FOR_DELIVERY' || shipmentdata?.tracking_summary?.delivery_status === 'INTRANSIT' || shipmentdata?.tracking_summary?.delivery_status === 'PICKED_UP_BY_CARRIER' ? "completed-timeline" : ''} ${shipmentdata?.tracking_summary?.delivery_status === 'READY_TO_SHIP' || shipmentdata?.tracking_summary?.delivery_status === 'SHIPMENT_CONFIRMED' ? 'active-timeline' : ''}`}>
                                                                                                <TimelineSeparator>
                                                                                                    <TimelineDot />
                                                                                                    <TimelineConnector />
                                                                                                </TimelineSeparator>
                                                                                                <TimelineContent>
                                                                                                    <div className='order-timeline-content'>
                                                                                                        <h3>Ready To Ship</h3>
                                                                                                        {shipmentdata?.tracking_summary?.shipment_event?.event_dttm?.formatted_dttm ? <span>{shipmentdata?.tracking_summary?.shipment_event?.event_dttm?.formatted_dttm ? formatingDateForDisplay(shipmentdata.tracking_summary.shipment_event.event_dttm.formatted_dttm) : ''}</span> : ''}
                                                                                                    </div>
                                                                                                </TimelineContent>
                                                                                            </TimelineItem>
                                                                                            <TimelineItem className={`${shipmentdata?.tracking_summary?.delivery_status === 'DELIVERED' ? "completed-timeline" : ''} ${shipmentdata?.tracking_summary?.delivery_status === 'OUT_FOR_DELIVERY' || shipmentdata?.tracking_summary?.delivery_status === 'INTRANSIT' || shipmentdata?.tracking_summary?.delivery_status === 'PICKED_UP_BY_CARRIER' ? 'active-timeline' : ''}`}>
                                                                                                <TimelineSeparator>
                                                                                                    <TimelineDot />
                                                                                                    <TimelineConnector />
                                                                                                </TimelineSeparator>
                                                                                                <TimelineContent >
                                                                                                    <div className='order-timeline-content'>
                                                                                                        <h3>Left Warehouse</h3>
                                                                                                        {shipmentdata?.tracking_summary?.pickup_event?.event_dttm?.formatted_dttm ? <span>{formatingDateForDisplay(shipmentdata.tracking_summary.pickup_event.event_dttm.formatted_dttm)}</span> : ''}
                                                                                                    </div>
                                                                                                </TimelineContent>
                                                                                            </TimelineItem>
                                                                                            <TimelineItem className={`${shipmentdata?.tracking_summary?.delivery_event && shipmentdata?.tracking_summary?.delivery_status === 'DELIVERED' ? 'completed-timeline' : ''}`}>
                                                                                                <TimelineSeparator>
                                                                                                    <TimelineDot />
                                                                                                </TimelineSeparator>
                                                                                                <TimelineContent>
                                                                                                    <div className='order-timeline-content'>
                                                                                                        <h3>Delivered</h3>
                                                                                                        {(shipmentdata?.tracking_summary?.delivery_status === 'DELIVERED' || shipmentdata?.tracking_summary?.delivery_event?.event_dttm?.formatted_dttm) && (
                                                                                                            <span>
                                                                                                                {shipmentdata?.tracking_summary?.delivery_status === 'DELIVERED' && shipmentdata?.tracking_summary?.delivery_event?.event_dttm?.formatted_dttm && (
                                                                                                                    <span>{formatingDateForDisplay(shipmentdata.tracking_summary.delivery_event.event_dttm.formatted_dttm)}</span>
                                                                                                                )}
                                                                                                            </span>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </TimelineContent>
                                                                                            </TimelineItem>
                                                                                        </Timeline>
                                                                                    </div>
                                                                                </div>
                                                                                </>}
                                                                            </React.Fragment>
                                                                        }>
                                                                        {(
                                                                            <div className={`order-delivered-wrapper cursor-pointer ${data1.type}`} onClick={e => setTrackShow(true)}>
                                                                                <p>{shipmentdata?.tracking_summary?.delivery_status === 'DELIVERED' ? <span>Your package has been delivered on {shipmentdata?.tracking_summary?.delivery_event?.event_dttm?.formatted_dttm ? formatingDateForDisplay(shipmentdata.tracking_summary.delivery_event.event_dttm.formatted_dttm) : ''}</span> : shipmentdata?.tracking_summary?.delivery_status === 'READY_TO_SHIP' || shipmentdata?.tracking_summary?.delivery_status === 'SHIPMENT_CONFIRMED' ? <span>Picked, packed and ready to ship</span> : shipmentdata?.tracking_summary?.delivery_status === 'OUT_FOR_DELIVERY' ? <span>Your package is out for delivery</span> : shipmentdata?.tracking_summary?.delivery_status !== 'OUT_FOR_DELIVERY' || shipmentdata?.tracking_summary?.delivery_status !== 'DELIVERED' || shipmentdata?.tracking_summary?.delivery_status !== 'READY_TO_SHIP' ? <span>The package is on it's way</span> : ''}</p>
                                                                                <img src={downArrowIcon} alt='downArrowIcon' />
                                                                            </div>
                                                                        )}
                                                                    </HtmlTooltipForDetails>
                                                                    {shipmentdata.tracking_summary.latest_track_event?.event_description ?
                                                                        <p className={`order-delivered-info display-ellipsis ${data1.type}`}>
                                                                            {shipmentdata.tracking_summary.latest_track_event?.event_description?.charAt(0).toUpperCase() + shipmentdata.tracking_summary.latest_track_event?.event_description?.slice(1).toLowerCase()}
                                                                        </p>
                                                                        : ''}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className={`order-info-wrapper ${data1.type} ${shipmentdata?.line_items?.length > 3 ? {innerScroll} : ''}`} >
                                                            {shipmentdata?.line_items.map((linedata, j) => (
                                                                <div className="order-info" key={j} id={`itemId` + linedata?.id}>
                                                                    <div
                                                                        className={`order-checkbox ${(linedata.return_context?.eligible_to_returns && linedata?.returnable_quantity > 0 && linedata.return_context?.max_return_date) ? '' : 'cursor-not-allowed'}`}>
                                                                        {
                                                                            !(linedata?.return_context?.eligible_to_returns && linedata?.returnable_quantity > 0 && linedata.return_context?.max_return_date) ?
                                                                                <HtmlTooltipForAddress enterTouchDelay={0}
                                                                                    title={
                                                                                        <React.Fragment>
                                                                                            <div onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} className="fw-500 f-14">
                                                                                                {(linedata.return_summary === null || linedata.return_summary.length === 0 ?
                                                                                                    <div>{(linedata.return_context?.in_eligible_reason) ? (linedata.return_context?.in_eligible_reason) : (linedata.return_context?.max_return_date ? 'Return eligible until' : '')}
                                                                                                        &nbsp;{linedata.return_context?.max_return_date ? formatingDateForDisplay(linedata.return_context?.max_return_date?.formatted_dttm) : ''}</div> :
                                                                                                    <div >{returnSummaryBind(linedata.return_summary, JSON.parse(sessionStorage.getItem('config-data'))?.lineitems_level_info_message?.return_status_message)}</div>)}</div>
                                                                                        </React.Fragment>}>
                                                                                    {showtooltip || (
                                                                                        <>
                                                                                            <div className="checkbox-wrapper">
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    id={`order-input-${linedata.id}${shipmentdata.id}`}

                                                                                                    checked={isChecked(linedata.id,shipmentdata.id)}

                                                                                                    className={`${!(linedata?.return_context?.eligible_to_returns && linedata?.returnable_quantity > 0 && linedata.return_context?.max_return_date) ? 'cursor-not-allowed auto-pointer-events' : ''} order-checkbox`}

                                                                                                    disabled={!(linedata?.return_context?.eligible_to_returns && linedata?.returnable_quantity > 0 && linedata.return_context?.max_return_date)}

                                                                                                    onChange={e => { setCheckbox(e.target.checked, linedata, shipmentdata.id, key, data.order_id, linedata.id) }}
                                                                                                />
                                                                                                <label htmlFor={`order-input-${linedata.id}`}>
                                                                                                    <span>
                                                                                                        <img src={whiteCheckIcon} alt='checkIcon' />
                                                                                                    </span>
                                                                                                </label>
                                                                                            </div>
                                                                                        </>
                                                                                    )}
                                                                                </HtmlTooltipForAddress>
                                                                                :
                                                                                (
                                                                                    <div className={`${data1?.type} checkbox-wrapper`}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            id={`order-input-${linedata.id}`}
                                                                                            checked={isChecked(linedata.id,shipmentdata.id)}
                                                                                            className={`${data1?.type} order-checkbox`}
                                                                                            disabled={
                                                                                                !(linedata.return_context?.eligible_to_returns && linedata.returnable_quantity > 0 && linedata.return_context?.max_return_date)
                                                                                            }
                                                                                            onChange={e => { setCheckbox(e.target.checked, linedata, shipmentdata.id, key, data.order_id, linedata.id) }}
                                                                                        />
                                                                                        <label htmlFor={`order-input-${linedata.id}`}>
                                                                                            <span>
                                                                                                <img src={whiteCheckIcon} alt='checkIcon' />
                                                                                            </span>
                                                                                        </label>
                                                                                    </div>
                                                                                )
                                                                        }
                                                                    </div>
                                                                    <div className='order-image-wrapper'>
                                                                        <div className={`order-image ${!linedata.image_url ? 'no-order-image' : ''} `}>
                                                                            {data1.type !== 'fluentcommerce' ?
                                                                                <img
                                                                                    className={`img-block border-image mb-10 cursor-pointer ${!linedata.image_url ? "width-45per" : ""}`}
                                                                                    onClick={() => window.open(linedata?.routing_url ? linedata?.routing_url : data1?.store_url)} alt='linedata' src={linedata.image_url ? `${linedata.image_url}` : '/shopping-bag.png'}
                                                                                    onError={addDefaultImg} style={{ width: 100 + 'px' }}
                                                                                /> :
                                                                                <img
                                                                                    className={`img-block border-image mb-10 cursor-pointer ${!linedata.image_url ? "width-45per" : ""}`}
                                                                                    onClick={() => window.open(data1?.store_url)} alt='linedata'
                                                                                    src={linedata.image_url ? `${linedata.image_url}` : '/shopping-bag.png'}
                                                                                    onError={addDefaultImg}
                                                                                    style={{ width: 100 + 'px' }}
                                                                                />
                                                                            }
                                                                        </div>
                                                                        {
                                                                            linedata?.product_name ? <div className={`product_name_wrapper ${data?.type}`}>
                                                                                <h4 className={`display-ellipsis ${data?.type}`}>
                                                                                    {linedata?.product_name}
                                                                                </h4>
                                                                            </div> : (
                                                                                <>
                                                                                    <div className={`product_name_wrapper ${data?.type}`}>
                                                                                        <h4 className={`display-ellipsis ${data?.type}`}>
                                                                                            {linedata?.sku}
                                                                                        </h4>
                                                                                    </div>
                                                                                </>
                                                                            )
                                                                        }
                                                                    </div>
                                                                    <div className="order-desc flex-grow-1">
                                                                        <div className='desc-content gap-18'>
                                                                            <div className='product_info'>
                                                                                {
                                                                                    linedata?.product_name ? <div className={`product_name_wrapper ${data?.type}`}>
                                                                                        <h4 className={`display-ellipsis ${data?.type}`}>
                                                                                            {linedata?.product_name}
                                                                                        </h4>
                                                                                    </div> : (
                                                                                        <>
                                                                                            <div className={`product_name_wrapper ${data?.type}`}>
                                                                                                <h4 className={`display-ellipsis ${data?.type}`}>
                                                                                                    {linedata?.sku}
                                                                                                </h4>
                                                                                            </div>
                                                                                        </>
                                                                                    )
                                                                                }
                                                                                {(linedata?.color || linedata?.size || linedata?.quantity) ?
                                                                                    <div className='size_color_wrapper'>
                                                                                        {displaySizeandColor(linedata?.size, linedata?.color, linedata?.quantity)}
                                                                                    </div> : ''
                                                                                }
                                                                            </div>
                                                                            {(linedata.return_summary === null || linedata.return_summary.length === 0 ?
                                                                                (linedata.return_context?.max_return_date && linedata.return_context?.policy_id && !(linedata.return_context?.expire_return_window) ?
                                                                                    <p className={`dark-grey-text ${linedata.return_context?.eligible_to_returns ? data1.type : "warning-color"}`}>
                                                                                        <img className="info-icon" src={infoIcon} alt="info-icon" />
                                                                                        {(linedata.return_context?.in_eligible_reason) ?
                                                                                            (linedata.return_context?.in_eligible_reason) : (linedata.return_context?.max_return_date ? JSON.parse(sessionStorage.getItem('config-data'))?.lineitems_level_info_message?.return_eligibility_message : '')}
                                                                                        &nbsp;{linedata.return_context?.max_return_date ? formatingDateForDisplay(linedata.return_context?.max_return_date?.formatted_dttm) : ''}
                                                                                    </p> : (linedata.return_context?.expire_return_window ? <p  className={`dark-grey-text ${linedata.return_context?.eligible_to_returns ? data1.type : "warning-color"}`} >
                                                                                        <img className="info-icon" src={infoIcon} alt="info-icon" />
                                                                                        {JSON.parse(sessionStorage.getItem('config-data'))?.lineitems_level_info_message?.return_window_expiry_message} {formatingDateForDisplay(linedata.return_context?.max_return_date?.formatted_dttm)}
                                                                                    </p> :
                                                                                    (!(linedata.return_context?.policy_id) && <p  className={`dark-grey-text ${linedata.return_context?.eligible_to_returns ? data1.type : "warning-color"}`} >
                                                                                    <img className="info-icon" src={infoIcon} alt="info-icon" />
                                                                                    {JSON.parse(sessionStorage.getItem('config-data'))?.lineitems_level_info_message?.no_policy_found_message}
                                                                                   </p>))
                                                                                ) :
                                                                                <p className={`red-text ${linedata.return_summary !== null ? 'janieandjack-red-color' : "warning-color"}`}>
                                                                                    <img className="info-icon" src={infoIcon} alt="info-icon" />
                                                                                    {returnSummaryBind(linedata.return_summary, JSON.parse(sessionStorage.getItem('config-data'))?.lineitems_level_info_message?.return_status_message)}
                                                                                </p>)
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className='quantity-container'>
                                                                        <div className='quantity-wrapper qty-wrap custom-select'>
                                                                            <label>Returnable Qty:</label>
                                                                            <div>
                                                                                <React.Fragment key={j}>
                                                                                    <FormControl sx={{ m: 1, minWidth: 90, mb: 2 }} size="small" variant='outlined'>
                                                                                        <Select classes={{
                                                                                            root: "quantity-select-root",
                                                                                        }}
                                                                                            IconComponent={NoIcon} value={quantityValueBind(linedata) ? quantityValueBind(linedata) : '0'} disabled={quantityDisable(linedata)} onChange={e => quantityChange(e, linedata.id)} className={`${data1.type} form-select ml-10 box-shadow-none cursor-pointer f-14 ${quantityDisable(linedata) ? 'cursor-not-allowed' : ''}`}>
                                                                                            {(linedata?.returnable_quantity > 0) ? (new Array((linedata?.returnable_quantity > 0) ? (linedata?.returnable_quantity) : 0).fill("").map((_, i) => i + 1).map((num, n) => { return <MenuItem className={`f-14 quantity-menuitem ${data1.type + '-menuitem'}`} key={n} value={num}>{num}</MenuItem> })) : <MenuItem className={`f-14 ${data1.type + '-menuitem'}`} value="0">0</MenuItem>}
                                                                                        </Select>
                                                                                    </FormControl>
                                                                                </React.Fragment>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>}
                                    <div className='row mx-0 pb-2'>
                                            {data?.non_shipped_line_items.length > 0 ?
                                                <div className={`${data?.shipments.length > 0 ? 'dashed-line mt-20' : ''}`}>
                                                    <div className="mt-0 mt-md-2 mb-20 f-14 fw-700 dark-grey-color not-shipped-text">
                                                        {JSON.parse(sessionStorage.getItem('config-data'))?.unshipped_items_section_title}
                                                    </div></div> : ''}
                                        <div className={`order-info-wrapper ${data?.non_shipped_line_items?.length > 3 ? 'auto-overflowY' : ''}`}>
                                            {data?.non_shipped_line_items?.map((nonshippeddata, i) => (
                                                <div className={`order-info not-shipped-yet `} key={i}>
                                                    <div className="col-md-12">
                                                        <div className={`order-info `}>
                                                            <div className='order-checkbox cursor-not-allowed'>
                                                                <HtmlTooltipForAddress enterTouchDelay={0}
                                                                    title={
                                                                        <React.Fragment>
                                                                            <div onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} className="fw-500 f-14">{JSON.parse(sessionStorage.getItem('config-data'))?.lineitems_level_info_message?.non_delivered_message}</div>
                                                                        </React.Fragment>}>
                                                                    {showtooltip || (
                                                                        <>
                                                                            <div className={`${data1?.type} checkbox-wrapper`}>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id={`order-input-${i}`}
                                                                                    className={`cursor-not-allowed auto-pointer-events order-checkbox`}
                                                                                    disabled={true}
                                                                                />
                                                                                <label htmlFor={`order-input-${i}`}>
                                                                                    <span>
                                                                                        <img src={whiteCheckIcon} alt='checkIcon' />
                                                                                    </span>
                                                                                </label>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </HtmlTooltipForAddress>
                                                            </div>
                                                            <div className="order-image-wrapper">
                                                                <div className={`order-image  ${!nonshippeddata.image_url ? 'no-order-image' : ''}`}>
                                                                    {data1.type !== 'fluentcommerce' ?
                                                                        <img className={`img-block border-image mb-10 cursor-pointer ${!nonshippeddata.image_url ? "width-45per" : ""}`}
                                                                            onClick={() => window.open(nonshippeddata?.routing_url ? nonshippeddata?.routing_url : data1?.store_url)} alt='linedata' src={nonshippeddata.image_url ? `${nonshippeddata.image_url}` : '/shopping-bag.png'}
                                                                            onError={addDefaultImg} style={{ width: 100 + 'px' }} />
                                                                        :
                                                                        <img className={`img-block border-image mb-10 cursor-pointer ${!nonshippeddata.image_url ? "width-45per" : ""}`}
                                                                            onClick={() => window.open(data1.store_url)} alt='linedata' src={nonshippeddata.image_url ? `${nonshippeddata.image_url}` : '/shopping-bag.png'}
                                                                            onError={addDefaultImg} style={{ width: 100 + 'px' }} />
                                                                    }
                                                                </div>
                                                                {nonshippeddata?.product_name ?
                                                                    <div className={`product_name_wrapper  ${data1?.type} ${nonshippeddata.product_name?.length > 60 ? '' : 'width-fit-content'}`}>
                                                                        <h4 className='display-ellipsis'>{nonshippeddata.product_name}</h4>
                                                                    </div> :
                                                                    <div className={`product_name_wrapper  ${data1?.type} ${nonshippeddata.sku?.length > 60 ? '' : 'width-fit-content'}`}>
                                                                        <h4 className='display-ellipsis'>{nonshippeddata?.sku}</h4>
                                                                    </div>
                                                                }

                                                            </div>
                                                            <div className="order-desc flex-grow-1">
                                                                <div className='desc-content'>
                                                                    <div className='product_info'>
                                                                        {nonshippeddata?.product_name ?
                                                                            <div className={`product_name_wrapper  ${data1?.type} ${nonshippeddata.product_name?.length > 60 ? '' : 'width-fit-content'}`}>
                                                                                <h4 className='display-ellipsis'>{nonshippeddata.product_name}</h4>
                                                                            </div> :
                                                                            <div className={`product_name_wrapper  ${data1?.type} ${nonshippeddata?.sku?.length > 60 ? '' : 'width-fit-content'}`}>
                                                                                <h4 className='display-ellipsis'>{nonshippeddata?.sku}</h4>
                                                                            </div>
                                                                        }
                                                                        {(nonshippeddata?.color || nonshippeddata?.size) ?
                                                                            <div className='size_color_wrapper'>
                                                                                {displaySizeandColor(nonshippeddata?.size, nonshippeddata?.color, nonshippeddata?.quantity)}
                                                                            </div> : ''
                                                                        }
                                                                        {(nonshippeddata?.vendor) ?
                                                                            <div className="size_color_wrapper"><span>Sold and Shipped by: {nonshippeddata?.vendor}</span></div> : null
                                                                        }
                                                                    </div>
                                                                    <p className="disabled-text">
                                                                        <img className="info-icon" src={infoIcon} alt="info-icon" />
                                                                        {JSON.parse(sessionStorage.getItem('config-data'))?.lineitems_level_info_message?.non_delivered_message}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className='quantity-container'>
                                                                <div className='quantity-wrapper qty-wrap custom-select'>
                                                                    <label>Returnable Qty:</label>
                                                                    <div>
                                                                        <React.Fragment key={i}>
                                                                            <FormControl sx={{ m: 1, minWidth: 90, mb: 2 }} size="small" variant='outlined'>
                                                                                <Select IconComponent={NoIcon} value={quantityValueBindForNonShipped(nonshippeddata)} disabled={quantityDisable(nonshippeddata)} onChange={e => quantityChange(e, nonshippeddata.id)} className={`${data1.type} form-select ml-10 box-shadow-none cursor-pointer f-14 ${quantityDisable(nonshippeddata) ? 'cursor-not-allowed' : ''}`}>
                                                                                    {new Array(nonshippeddata?.quantity).fill("").map((_, i) => i + 1).map((num, n) => { return <MenuItem className={`f-14 ${data1.type + '-menuitem'}`} key={n} value={num}>{num}</MenuItem> })}
                                                                                </Select>
                                                                            </FormControl>
                                                                        </React.Fragment>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}

                                        </div>
                                    </div>

                                    <div className='row text-right mr-10 ml-10 mm-x0 d-flex d-md-none'>
                                        <div className={`${data1.type === 'fluentcommerce' ? 'col-sm-0' : 'col-sm'} col-lg col-md`}></div>
                                        {data1.type === 'fluentcommerce' ?
                                            <div className="col-lg-2 col-md-3 col-sm-4">
                                                <button className={`${data1.type} tertiary-btn full-width mb-16`} title='Extend Pickup Window'> Extend Pickup Window </button>
                                            </div> : ''}
                                        <div className="col-lg-2 col-md-3 col-sm-4">
                                            {
                                                !(lineDataArray?.length > 0 && data?.order_id === orderId) ?
                                                    <HtmlTooltipForAddress enterTouchDelay={0}
                                                        title={
                                                            <React.Fragment>
                                                                <div onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} className="fw-500">Please select lineitems to enable button</div>
                                                            </React.Fragment>}>
                                                        {showtooltip || (
                                                            <button className={`${data1?.type ? data1.type + '-btn' : ''} ${data1?.type === 'fluentcommerce' ? 'full-width' : ''} mb-16 float-right ${lineDataArray?.length > 0 && data.order_id === orderId ? '' : 'disabled-btn'}`} onClick={() => onReturnItem(data, lineDataArray)} >
                                                                Return Item(s)
                                                            </button>
                                                        )}
                                                    </HtmlTooltipForAddress>
                                                    : <button disabled={!(lineDataArray?.length > 0 && data.order_id === orderId)} className={`${data1?.type ? data1.type + '-btn' : ''} ${data1?.type === 'fluentcommerce' ? 'full-width' : ''} mb-16 float-right ${lineDataArray.length > 0 && data.order_id === orderId ? '' : 'disabled-btn'}`} onClick={() => onReturnItem(data, lineDataArray)} title='Return Item(s)'>
                                                        Return Item(s)
                                                    </button>
                                            }
                                        </div>
                                        {data1.type === 'fluentcommerce' ?
                                            <div className="col-lg-2 col-md-3 col-sm-4">
                                                <button className={`${data1.type} tertiary-btn full-width mb-16`} title='Cancel Order'> Cancel Order </button>
                                            </div> : ''}
                                    </div>
                                </div> : ''
                                }

                            </div>
                        </div>
                    ))) : filterData === null ? <div className={`${data1.type} f-14 fw-500 text-center min-height-50 align-center mt-16`}>
                        <div className='no-orders-border-line p-20'>
                            Welcome to <span className="fw-700">{data1?.vendorName}</span> Return Portal.
                            {searchValueDummy ?
                                <div>It looks like you don’t have an order for <span className="fw-700 display-ellipsis">Order Number: {searchValueDummy}</span></div>
                                : (sessionStorage.getItem('email') ? <div>It looks like you don’t have any orders for <span className="fw-700 display-ellipsis">{JSON.parse(sessionStorage.getItem('email'))}</span></div>
                                    : (ordernumber ? <div>It looks like you don’t have an order for <span className="fw-700 display-ellipsis">Order Number:  {ordernumber}  & Zipcode:  {zipcode}</span></div> : <div>It looks like you don’t have an order for <span className="fw-700 display-ellipsis">Order Id:  {orderIdParam}</span></div>))}
                            <div><a href={() => false} className={`${data1.type} fw-700 cursor-pointer`} onClick={gobacktologin}>Logout</a></div> </div></div> : ''}
                </div>
            </div>
            {totalCount > 10 ?
                <div className='custom_pagination'>

                    <div className='pagination-wrap'>
                        <div className='pagination_result_container'>
                            <label>Results:</label>
                            <FormControl sx={{ m: 1, minWidth: 90, mb: 2 }} size="small" variant='outlined'>
                                <Select classes={{
                                    root: "result-select-root",
                                }}
                                    value={rowsPerPage}
                                    onChange={handleChangeRowsPerPage}
                                    IconComponent={NoIcon}
                                    className={`form-select box-shadow-none cursor-pointer f-14`}>
                                    <MenuItem className={`f-14 quantity-menuitem ${data1.type + '-menuitem'}`} value="10">10</MenuItem>
                                    <MenuItem className={`f-14 quantity-menuitem ${data1.type + '-menuitem'}`} value="50">50</MenuItem>
                                    <MenuItem className={`f-14 quantity-menuitem ${data1.type + '-menuitem'}`} value="100">100</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div className='pagination_container'>
                            <Pagination
                                className={`${data1?.type} table-page`}
                                count={totalPages}
                                variant="outlined"
                                onChange={handleChangePage}
                                shape="rounded"
                                page={page}
                                currentpage={currentpage}
                                renderItem={(item) => (
                                    <PaginationItem
                                        slots={{
                                            previous: () => (
                                                <Typography variant="label">Previous</Typography>
                                            ),
                                            next: () => (
                                                <Typography variant="label" sx={{ padding: "0 12px" }}>
                                                    Next
                                                </Typography>
                                            ),
                                        }}
                                        {...item}
                                    />
                                )}
                            />

                        </div>
                    </div>
                </div> : ''
            }
            <SimpleDialog
                open={open}
                onClose={dialogClose}
            />
        </div>
    )

    return (
        <div>
            {isLoaderEnable && !searchValue ?
                <div className="min-height-50 align-center loader">{JSON.parse(sessionStorage.getItem('config-data'))?.pageload_buffering_message?.my_orders_page}</div>
                : (
                    isSubmitted ? <div>
                        <ReturnItem
                            childData={handleCallback}
                            data={obj}
                            reasonData={reasonData}
                            HtmlTooltipForAddress={HtmlTooltipForAddress}
                            HtmlTooltipForDetails={HtmlTooltipForDetails}
                            displaySizeandColor={displaySizeandColor}
                        /></div> : renderForm)
            }
            <ScrollToTop />
            <Snackbar
                open={snackOpen}
                autoHideDuration={5000}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
            >
                <Alert
                    onClose={handleClose}
                    severity={snackbarProp.style}
                    variant="filled"
                    sx={{ width: '100%' }}
                >{snackbarProp.msg}
                </Alert></Snackbar>
        </div>
    );
}

export default MyOrders;